import { tns } from 'tiny-slider/src/tiny-slider';

const container = document.querySelector('.js-product-carousel');

if (container) {
    tns({
        container: container,
        items: 1,
        autoplay: true,
        controls: false,
        navContainer: '.tns-nav',
        autoplayButtonOutput: false,
        mouseDrag: true
    });
}
